import common from './common.json';
import home from './home.json';
import canvas from './canvas.json';
import arena from './arena.json';
import user from './user.json';
import content from './content.json';
import copilot from './copilot.json';
import project from './project.json';

export default {
  ...common,
  ...home,
  ...canvas,
  ...arena,
  ...user,
  ...content,
  ...copilot,
  ...project,
};
